import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const API = (process.env.REACT_APP_API_URL || 'http://localhost:8000') + '/api/ic-kontrol';

const BILESENLER = [
  { kod: 'KO', adi: 'Kontrol Ortamı',     ikon: '🏛️', renk: '#1a56db', standart: '1-4',  yol: 'standartlar?bilesen=KO' },
  { kod: 'RY', adi: 'Risk Yönetimi',      ikon: '⚠️', renk: '#d03801', standart: '5-6',  yol: 'riskler'               },
  { kod: 'KF', adi: 'Kontrol Faaliyetleri',ikon: '✅', renk: '#057a55', standart: '7-12', yol: 'faaliyetler'            },
  { kod: 'BI', adi: 'Bilgi ve İletişim',  ikon: '📡', renk: '#7e3af2', standart: '13-16',yol: 'bildirimler'            },
  { kod: 'IZ', adi: 'İzleme',             ikon: '🔍', renk: '#b45309', standart: '17-18', yol: 'standartlar?bilesen=IZ' },
];

function RiskHaritasi({ riskler }: { riskler: any[] }) {
  // 10x10 matris — basitleştirilmiş 5x5 görsel
  const matris: { [key: string]: number } = {};
  riskler.forEach(r => {
    const k = `${r.kalinti_olasilik}-${r.kalinti_etki}`;
    matris[k] = (matris[k] || 0) + 1;
  });

  const renk = (ola: number, etki: number) => {
    const p = ola * etki;
    if (p < 25) return '#d1fae5';
    if (p < 50) return '#fef3c7';
    return '#fee2e2';
  };

  const hucreRenk = (ola: number, etki: number) => {
    const p = ola * etki;
    if (p < 25) return '#065f46';
    if (p < 50) return '#92400e';
    return '#991b1b';
  };

  return (
    <div style={{ overflowX: 'auto' }}>
      <div style={{ display: 'grid', gridTemplateColumns: 'auto repeat(10,1fr)', gap: 2, minWidth: 320 }}>
        {/* Başlık */}
        <div style={{ gridColumn: '1', gridRow: '1', padding: '4px', fontSize: 10, color: '#6b7280', textAlign: 'center' }}>
          ETKİ↓<br />OLASILIK→
        </div>
        {[...Array(10)].map((_, i) => (
          <div key={i} style={{ textAlign: 'center', fontSize: 10, color: '#6b7280', padding: 2 }}>{i + 1}</div>
        ))}
        {[...Array(10)].map((_, etki) => (
          <>
            <div key={`l-${etki}`} style={{ fontSize: 10, color: '#6b7280', padding: '2px 4px', display: 'flex', alignItems: 'center' }}>
              {10 - etki}
            </div>
            {[...Array(10)].map((_, ola) => {
              const e = 10 - etki;
              const o = ola + 1;
              const key = `${o}-${e}`;
              const sayi = matris[key] || 0;
              return (
                <div key={`h-${etki}-${ola}`} style={{
                  background: renk(o, e),
                  color: hucreRenk(o, e),
                  width: '100%', aspectRatio: '1',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: 10, fontWeight: sayi > 0 ? 700 : 400,
                  borderRadius: 2, border: '1px solid rgba(0,0,0,0.05)'
                }}>
                  {sayi > 0 ? sayi : ''}
                </div>
              );
            })}
          </>
        ))}
      </div>
      <div style={{ display: 'flex', gap: 12, marginTop: 8, fontSize: 11 }}>
        <span><span style={{ display: 'inline-block', width: 12, height: 12, background: '#d1fae5', border: '1px solid #a7f3d0', borderRadius: 2 }} /> Düşük</span>
        <span><span style={{ display: 'inline-block', width: 12, height: 12, background: '#fef3c7', border: '1px solid #fde68a', borderRadius: 2 }} /> Orta</span>
        <span><span style={{ display: 'inline-block', width: 12, height: 12, background: '#fee2e2', border: '1px solid #fecaca', borderRadius: 2 }} /> Yüksek</span>
      </div>
    </div>
  );
}

export default function IcKontrolAnaSayfa() {
  const nav = useNavigate();
  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };

  const [ozet, setOzet] = useState<any>(null);
  const [standartOzet, setStandartOzet] = useState<any>({});
  const [riskler, setRiskler] = useState<any[]>([]);
  const [yukleniyor, setYukleniyor] = useState(true);

  useEffect(() => {
    Promise.all([
      fetch(`${API}/ozet`, { headers }).then(r => r.json()),
      fetch(`${API}/standartlar/ozet`, { headers }).then(r => r.json()),
      fetch(`${API}/riskler`, { headers }).then(r => r.json()),
    ]).then(([oz, st, rk]) => {
      setOzet(oz);
      setStandartOzet(st);
      setRiskler(Array.isArray(rk) ? rk : []);
      setYukleniyor(false);
    }).catch(() => setYukleniyor(false));
  }, []);

  if (yukleniyor) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '60vh' }}>
      <div style={{ textAlign: 'center', color: '#6b7280' }}>
        <div style={{ fontSize: 40 }}>⏳</div>
        <p>Yükleniyor...</p>
      </div>
    </div>
  );

  const toplamUyum = ozet?.standart?.toplam ?? 79; // 79: Kamu İç Kontrol Standartları sabit şart sayısı
  const tamUyumlu = ozet?.standart?.tam_uyumlu || 0;
  const uyumOrani = ozet?.standart?.uyum_orani || 0;

  return (
    <div style={{ padding: '24px', maxWidth: 1200 }}>
      {/* Başlık */}
      <div style={{ marginBottom: 24 }}>
        <h1 style={{ margin: 0, fontSize: 24, color: '#111827', fontWeight: 700 }}>
          İç Kontrol Yönetim Sistemi
        </h1>
        <p style={{ margin: '4px 0 0', color: '#6b7280', fontSize: 14 }}>
          5018 Sayılı Kanun • COSO Modeli • Kamu İç Kontrol Standartları (18 Standart / 79 Genel Şart)
        </p>
      </div>

      {/* Yasal Dayanak Bandı */}
      <div style={{
        background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: 8,
        padding: '10px 16px', marginBottom: 24, display: 'flex', alignItems: 'center', gap: 12
      }}>
        <span style={{ fontSize: 20 }}>⚖️</span>
        <div style={{ fontSize: 13, color: '#1e40af' }}>
          <strong>Yasal Dayanak:</strong> 5018 Sayılı Kamu Mali Yönetimi ve Kontrol Kanunu (md. 55-64) &bull;{' '}
          Kamu İç Kontrol Standartları Tebliği (26.12.2007 / 26738) &bull;{' '}
          Kamu İç Kontrol Rehberi (Maliye Bakanlığı, v1.0)
        </div>
      </div>

      {/* KPI Kartları */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, marginBottom: 24 }}>
        <KpiKart baslik="Toplam Risk" deger={ozet?.risk?.toplam || 0} ikon="⚠️"
          alt={`${ozet?.risk?.yuksek || 0} yüksek, ${ozet?.risk?.orta || 0} orta`}
          renk="#fee2e2" onClick={() => nav('riskler')} />
        <KpiKart baslik="Yüksek Risk" deger={ozet?.risk?.yuksek || 0} ikon="🔴"
          alt="Acil eylem gerektirir" renk="#fee2e2" onClick={() => nav('riskler?seviye=yuksek')} />
        <KpiKart baslik="Uyum Oranı" deger={`%${uyumOrani}`} ikon="📊"
          alt={`${tamUyumlu} / ${toplamUyum} şart tam uyumlu`}
          renk="#d1fae5" onClick={() => nav('standartlar')} />
        <KpiKart baslik="Bekleyen Bildirim" deger={ozet?.bildirim?.bekleyen || 0} ikon="📋"
          alt="İnceleme bekleyen bildirimler" renk="#fef3c7" onClick={() => nav('bildirimler')} />
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20, marginBottom: 24 }}>
        {/* COSO Bileşenleri */}
        <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 10, padding: 20 }}>
          <h2 style={{ margin: '0 0 16px', fontSize: 16, color: '#111827' }}>🧩 COSO Bileşenleri</h2>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {BILESENLER.map(b => {
              const bilesen = standartOzet[b.kod] || {};
              const oran = bilesen.uyum_orani || 0;
              return (
                <div key={b.kod} style={{
                  display: 'flex', alignItems: 'center', gap: 12,
                  padding: '10px 12px', borderRadius: 8, background: '#f9fafb',
                  border: '1px solid #e5e7eb', cursor: 'pointer', transition: 'background 0.15s'
                }}
                  onClick={() => nav(b.yol)}
                  onMouseEnter={e => (e.currentTarget.style.background = '#f3f4f6')}
                  onMouseLeave={e => (e.currentTarget.style.background = '#f9fafb')}
                >
                  <span style={{ fontSize: 22 }}>{b.ikon}</span>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontWeight: 600, fontSize: 13, color: '#111827' }}>{b.adi}</div>
                    <div style={{ fontSize: 11, color: '#6b7280' }}>Standart {b.standart}</div>
                    <div style={{ marginTop: 4, height: 6, background: '#e5e7eb', borderRadius: 3, overflow: 'hidden' }}>
                      <div style={{
                        height: '100%', width: `${oran}%`,
                        background: oran >= 75 ? '#10b981' : oran >= 50 ? '#f59e0b' : '#ef4444',
                        borderRadius: 3, transition: 'width 0.5s'
                      }} />
                    </div>
                  </div>
                  <div style={{
                    fontWeight: 700, fontSize: 14,
                    color: oran >= 75 ? '#065f46' : oran >= 50 ? '#92400e' : '#991b1b',
                    minWidth: 40, textAlign: 'right'
                  }}>
                    %{oran}
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Risk Haritası */}
        <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 10, padding: 20 }}>
          <h2 style={{ margin: '0 0 4px', fontSize: 16, color: '#111827' }}>📍 Risk Haritası</h2>
          <p style={{ margin: '0 0 12px', fontSize: 12, color: '#6b7280' }}>Kalıntı risk: Olasılık × Etki (10×10 matris)</p>
          <RiskHaritasi riskler={riskler} />
        </div>
      </div>

      {/* Son Yüksek Riskler */}
      <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 10, padding: 20, marginBottom: 20 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
          <h2 style={{ margin: 0, fontSize: 16, color: '#111827' }}>🚨 Yüksek Riskler</h2>
          <button onClick={() => nav('riskler')} style={{
            background: 'none', border: '1px solid #d1d5db', borderRadius: 6,
            padding: '4px 12px', cursor: 'pointer', fontSize: 13, color: '#374151'
          }}>Tümünü Gör →</button>
        </div>
        {riskler.filter(r => r.kalinti_seviye === 'yuksek').slice(0, 5).length === 0 ? (
          <div style={{ textAlign: 'center', padding: '20px', color: '#6b7280', fontSize: 14 }}>
            ✅ Yüksek seviyeli risk bulunmamaktadır.
          </div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead>
              <tr style={{ background: '#f9fafb' }}>
                <th style={{ padding: '8px 12px', textAlign: 'left', border: '1px solid #e5e7eb', color: '#374151' }}>Risk No</th>
                <th style={{ padding: '8px 12px', textAlign: 'left', border: '1px solid #e5e7eb', color: '#374151' }}>Risk Adı</th>
                <th style={{ padding: '8px 12px', textAlign: 'left', border: '1px solid #e5e7eb', color: '#374151' }}>Birim</th>
                <th style={{ padding: '8px 12px', textAlign: 'center', border: '1px solid #e5e7eb', color: '#374151' }}>Kalıntı Puan</th>
                <th style={{ padding: '8px 12px', textAlign: 'center', border: '1px solid #e5e7eb', color: '#374151' }}>Cevap</th>
              </tr>
            </thead>
            <tbody>
              {riskler.filter(r => r.kalinti_seviye === 'yuksek').slice(0, 5).map(r => (
                <tr key={r.id} style={{ cursor: 'pointer' }} onClick={() => nav('riskler')}
                  onMouseEnter={e => (e.currentTarget.style.background = '#fef2f2')}
                  onMouseLeave={e => (e.currentTarget.style.background = '')}>
                  <td style={{ padding: '8px 12px', border: '1px solid #e5e7eb', fontFamily: 'monospace', color: '#374151' }}>{r.risk_no}</td>
                  <td style={{ padding: '8px 12px', border: '1px solid #e5e7eb', color: '#111827', maxWidth: 300 }}>
                    <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.risk_adi}</div>
                  </td>
                  <td style={{ padding: '8px 12px', border: '1px solid #e5e7eb', color: '#6b7280' }}>{r.birim_adi || '-'}</td>
                  <td style={{ padding: '8px 12px', border: '1px solid #e5e7eb', textAlign: 'center' }}>
                    <span style={{ background: '#fee2e2', color: '#991b1b', padding: '2px 8px', borderRadius: 12, fontWeight: 700 }}>
                      {r.kalinti_puan}
                    </span>
                  </td>
                  <td style={{ padding: '8px 12px', border: '1px solid #e5e7eb', textAlign: 'center', color: '#6b7280' }}>
                    {r.cevap_yontemi === 'kabul_et' ? 'Kabul' :
                     r.cevap_yontemi === 'kontrol_et' ? 'Kontrol' :
                     r.cevap_yontemi === 'devret' ? 'Devret' :
                     r.cevap_yontemi === 'kacin' ? 'Kaçın' : '-'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* Hızlı Erişim */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5,1fr)', gap: 12 }}>
        {[
          { ikon: '⚠️', baslik: 'Risk Kaydı',     yol: 'riskler',     aciklama: '6. Standart' },
          { ikon: '✅', baslik: 'Kontrol Faaliyetleri', yol: 'faaliyetler', aciklama: '7-12. Standart' },
          { ikon: '📋', baslik: 'Standart Uyum',   yol: 'standartlar', aciklama: '18 Standart / 79 Şart' },
          { ikon: '🚨', baslik: 'Bildirimler',     yol: 'bildirimler', aciklama: '16. Standart' },
          { ikon: '🔍', baslik: 'Değerlendirme',   yol: 'standartlar', aciklama: '17. Standart' },
        ].map(k => (
          <button key={k.yol + k.baslik} onClick={() => nav(k.yol)} style={{
            background: '#fff', border: '1px solid #e5e7eb', borderRadius: 10,
            padding: '16px 12px', cursor: 'pointer', textAlign: 'center', transition: 'all 0.15s'
          }}
            onMouseEnter={e => { (e.currentTarget as HTMLElement).style.borderColor = '#3b82f6'; (e.currentTarget as HTMLElement).style.background = '#eff6ff'; }}
            onMouseLeave={e => { (e.currentTarget as HTMLElement).style.borderColor = '#e5e7eb'; (e.currentTarget as HTMLElement).style.background = '#fff'; }}
          >
            <div style={{ fontSize: 28, marginBottom: 6 }}>{k.ikon}</div>
            <div style={{ fontWeight: 600, fontSize: 13, color: '#111827', marginBottom: 2 }}>{k.baslik}</div>
            <div style={{ fontSize: 11, color: '#9ca3af' }}>{k.aciklama}</div>
          </button>
        ))}
      </div>
    </div>
  );
}

function KpiKart({ baslik, deger, ikon, alt, renk, onClick }: any) {
  return (
    <div onClick={onClick} style={{
      background: '#fff', border: '1px solid #e5e7eb', borderRadius: 10,
      padding: '16px 20px', cursor: 'pointer', transition: 'all 0.15s'
    }}
      onMouseEnter={e => { (e.currentTarget as HTMLElement).style.borderColor = '#93c5fd'; (e.currentTarget as HTMLElement).style.boxShadow = '0 2px 8px rgba(59,130,246,0.1)'; }}
      onMouseLeave={e => { (e.currentTarget as HTMLElement).style.borderColor = '#e5e7eb'; (e.currentTarget as HTMLElement).style.boxShadow = ''; }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div>
          <div style={{ fontSize: 12, color: '#6b7280', fontWeight: 500, marginBottom: 4 }}>{baslik}</div>
          <div style={{ fontSize: 28, fontWeight: 800, color: '#111827', lineHeight: 1 }}>{deger}</div>
          <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 4 }}>{alt}</div>
        </div>
        <div style={{
          background: renk, borderRadius: 10, width: 44, height: 44,
          display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22
        }}>{ikon}</div>
      </div>
    </div>
  );
}
